import React from 'react'
import { Checkbox } from '@fs/zion-ui'
import { getPersonName } from '@fs/zion-sls'

/**
 * A single selectable name row.
 *
 * Two deliberate differences from {@link ../../linkNamesPanel/components/PersonCheckboxField}: the
 * label is the person's full name and nothing else, no relationship suffix; and the checkbox is
 * controlled by the caller rather than bound to a form, so a selection cannot be lost when the
 * person is filtered out of view.
 *
 * @param {Object} params
 * @param {Object} params.person - The SLS person element this row selects
 * @param {boolean} [params.checked=false] - Whether the person is currently selected
 * @param {boolean} [params.disabled=false] - Whether the row is selectable
 * @param {(personId: string) => void} [params.onToggle] - Called with the person id when toggled
 * @returns {React.ReactElement}
 */
const PersonNameCheckbox = ({ person, checked = false, disabled = false, onToggle = () => {} }) => (
  <Checkbox
    name={`person-name-checkbox-${person.id}`}
    label={getPersonName({ person })}
    checked={checked}
    disabled={disabled}
    onChange={() => onToggle(person.id)}
    data-testid={`person-name-checkbox-${person.id}`}
  />
)

export default PersonNameCheckbox
